import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getPromoStatus = async () => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `/promotion-status/list` });

  return data;
};

export default getPromoStatus;
